import { render, staticRenderFns } from "./Units.vue?vue&type=template&id=ad189f18&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"
import style0 from "./Units.vue?vue&type=style&index=0&id=ad189f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad189f18",
  null
  
)

export default component.exports